import { useQuery, useQueryClient } from '@tanstack/vue-query';
import { useApiClient } from '@/api/useApiClient';
import type { components } from '@/api/api-types';
import { useParentAuthStore } from '@/store/auth';


type Student = components['schemas']['Student'];

type GetStudentsQueryParams = {
  preferred_name?: string;
  first_name?: string;
  middle_name?: string;
  surname?: string;
  form_id?: string;
  country_id?: string;
  set_ids?: string[];
};

export const useParentStudents = (params?: GetStudentsQueryParams) => {
  const client = useApiClient();
   const authStore = useParentAuthStore();

  return useQuery({
    queryKey: ['parent-students', params],
    queryFn: async () => {
      const { data, error } = await client.GET('/parent/students', {
        params: { query: params }
      });
      if (error) throw error;
      return data;
    },
  });
};

export const useParentStudent = (id: string) => {
  const client = useApiClient();

  return useQuery({
    queryKey: ['parent-students', id],
    queryFn: async () => {
      const { data, error } = await client.GET('/parent/students/{id}', {
        params: { path: { id } }
      });
      if (error) throw error;
      return data;
    },
    enabled: !!id,
  });
};

export const useInvalidateParentStudents = () => {
  const queryClient = useQueryClient();
  
  return {
    invalidateList: () => queryClient.invalidateQueries({ queryKey: ['parent-students'] }),
    invalidateOne: (id: string) => queryClient.invalidateQueries({ queryKey: ['parent-students', id] }),
  };
};